/**
 * 响应式断点 Hook — 检测当前设备类型
 * 对齐 features.md 9.13 + platform-adaptation.md §一
 */

import { useState, useEffect } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export function useBreakpoint(): DeviceType {
  const [device, setDevice] = useState<DeviceType>('desktop');

  useEffect(() => {
    function update() {
      const width = window.innerWidth;
      if (width < 768) setDevice('mobile');
      else if (width < 1280) setDevice('tablet');
      else setDevice('desktop');
    }

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return device;
}
